{
  "ACCEPTED": "#CBFFAE",
  "OPEN": "#EFF0F6",
  "REJECTION": "#FFABE8",
  "FINAL": "#90DBF2",
  "RETRACTED": "#FFABE8",
  "EXTERN": "#4E4B66",
  "FIXED": "#14142c",
  "PENDING": "#fdf5dd",
  "REVISION": "#FFD8A8"
}
